/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';

import { TabContext, TabPanel } from '@mui/lab';
import { alpha, useTheme } from '@mui/material/styles';
import { Box, Tab, Card, Tabs, Stack, Container, CardHeader } from '@mui/material';

import { _fiscal_year, _mock, _server_list } from 'src/_mock';

import FullFeaturedCrudGrid from 'src/sections/_examples/mui/data-grid-view/dataGridCrud';
import { _security } from 'src/_mock/_security';
import { _securityInfra_cost_list } from 'src/_mock/securityInfra_assets';
import QAWrapperComponent from './QAWrapperComponent/QAWrapperComponent';

const Security = () => {
  const theme = useTheme();
  const [activeTab, setActiveTab] = useState('security');

  const _column_data: any = {
    type: {
      'Server OS': 'singleSelect',
      Version: 'text',
      SOC2: 'boolean',
      Supported: 'boolean',
      'Server Name': 'text',
      Refresh: 'date',
      'Last Patch': 'date',
      Name: 'text',
      Category: 'text',
      Cost: 'currency',
      Type: 'singleSelect',
    },
    options: {
      'Server OS': _server_list,
      Server: _server_list,
      Type: ['CapEx', 'OpEx'],
    },
    column_questions: {
      Server: 'What server OS do the applications run on?',
      Version: 'What is the server version?',
      SOC2: 'Do you collect SOC2 reports from your app vendor?',
      Supported: 'Is this server out of support?',
      Refresh: 'When is the server refresh due?',
      'Server Name': 'What is the server server?',
      'Last Patch': 'When was the last server security patch?',
    },
  };

  const gridData: any = {
    security_details: {
      _dataGrid_0: [...Array(2)].map((_, index) => {
        const status =
          (index % 2 && 'online') || (index % 3 && 'alway') || (index % 4 && 'busy') || 'offline';

        return {
          id: _mock.id(index),
          // status,
          'Name ': _mock.app_details.name(index),
          'Server OS': _security.server(index),
          Version: _security.version(index),
          SOC2: _security.soc2(index),
          Supported: _security.supported(index),
          'Server Name': _security.server_name(index),
          Refresh: _security.next_refresh(index),
          'Last Patch': _security.last_patch(index),
        };
      }),
    },
    // security_overhead: {
    //   titles: [...Array(10)].map((_, index) => `FY ${new Date().getFullYear() -1 + index}`),
    //   _dataGrid_0: [...Array(8)].map((_, index) => ({
    //     id: _mock.id(index),
    //     // 'Application Name': _app_quality.application_name(index),
    //     Name: _mock.app_details.name(index),
    //     Category: _mock.app_costs.category(index),
    //     Cost: _mock.app_costs.cost(index),
    //     Type: _mock.app_costs.type(index),
    //   })),
    // _dataGrid_1: [...Array(8)].map((_, index) => ({
    //     id: _mock.id(index),
    //     // 'Application Name': _app_quality.application_name(index),
    //     Name: _mock.app_details.name(index),
    //     Category: _mock.app_costs.category(index),
    //     Cost: _mock.app_costs.cost(index),
    //     Type: _mock.app_costs.type(index),
    //   })),
    // _dataGrid_2: [...Array(8)].map((_, index) => ({
    //     id: _mock.id(index),
    //     // 'Application Name': _app_quality.application_name(index),
    //     Name: _mock.app_details.name(index),
    //     Category: _mock.app_costs.category(index),
    //     Cost: _mock.app_costs.cost(index),
    //     Type: _mock.app_costs.type(index),
    //   })),
    // _dataGrid_3: [...Array(8)].map((_, index) => ({
    //     id: _mock.id(index),
    //     // 'Application Name': _app_quality.application_name(index),
    //     Name: _mock.app_details.name(index),
    //     Category: _mock.app_costs.category(index),
    //     Cost: _mock.app_costs.cost(index),
    //     Type: _mock.app_costs.type(index),
    //   })),
    // _dataGrid_4: [...Array(8)].map((_, index) => ({
    //     id: _mock.id(index),
    //     // 'Application Name': _app_quality.application_name(index),
    //     Name: _mock.app_details.name(index),
    //     Category: _mock.app_costs.category(index),
    //     Cost: _mock.app_costs.cost(index),
    //     Type: _mock.app_costs.type(index),
    //   })),
    // _dataGrid_5: [...Array(8)].map((_, index) => ({
    //     id: _mock.id(index),
    //     // 'Application Name': _app_quality.application_name(index),
    //     Name: _mock.app_details.name(index),
    //     Category: _mock.app_costs.category(index),
    //     Cost: _mock.app_costs.cost(index),
    //     Type: _mock.app_costs.type(index),
    //   })),
    // _dataGrid_6: [...Array(8)].map((_, index) => ({
    //     id: _mock.id(index),
    //     // 'Application Name': _app_quality.application_name(index),
    //     Name: _mock.app_details.name(index),
    //     Category: _mock.app_costs.category(index),
    //     Cost: _mock.app_costs.cost(index),
    //     Type: _mock.app_costs.type(index),
    //   })),
    // _dataGrid_7: [...Array(8)].map((_, index) => ({
    //     id: _mock.id(index),
    //     // 'Application Name': _app_quality.application_name(index),
    //     Name: _mock.app_details.name(index),
    //     Category: _mock.app_costs.category(index),
    //     Cost: _mock.app_costs.cost(index),
    //     Type: _mock.app_costs.type(index),
    //   })),
    // _dataGrid_8: [...Array(8)].map((_, index) => ({
    //     id: _mock.id(index),
    //     // 'Application Name': _app_quality.application_name(index),
    //     Name: _mock.app_details.name(index),
    //     Category: _mock.app_costs.category(index),
    //     Cost: _mock.app_costs.cost(index),
    //     Type: _mock.app_costs.type(index),
    //   })),
    // _dataGrid_9: [...Array(8)].map((_, index) => ({
    //     id: _mock.id(index),
    //     // 'Application Name': _app_quality.application_name(index),
    //     Name: _mock.app_details.name(index),
    //     Category: _mock.app_costs.category(index),
    //     Cost: _mock.app_costs.cost(index),
    //     Type: _mock.app_costs.type(index),
    //   })),
    // },
  };
  const modifyGridData = (Obj_key: any, gridData_obj: any) => {
    const output: any = {
      [Obj_key]: {
        titles: [...Array(10)].map((_, index) => `FY ${_fiscal_year[index]}`),
      },
    };
    // eslint-disable-next-line
    for (let i = 0; i < 10; i++) {
      const dataGridKey = `_dataGrid_${i}`;
      output[Obj_key][dataGridKey] = [...Array(8)].map((_, index) => ({
        id: _mock.id(index),
        // Name: _mock.app_details.name(index),
        Category: _mock.app_costs.category(index),
        Cost: _securityInfra_cost_list?.[`${Obj_key}_${i}`]?.[index],
        Type: _mock.app_costs.type(index),
      }));
    }

    gridData_obj[Obj_key] = output[Obj_key];
  };

  modifyGridData('security_overhead', gridData);

  const TABS = [
    { value: 'security_details', label: 'Details', color: 'success' },
    { value: 'security_overhead', label: 'Overhead', color: 'success' },
  ] as const;

  return (
    <>
      <Helmet>
        <title> Dashboard: Security & Infrastructure</title>
      </Helmet>

      <QAWrapperComponent
        TABS={TABS}
        gridData={gridData}
        _column_data={_column_data}
        title="Security & Infrastructure"
        initialState={{
          aggregation: {
            model: {
              // Cost: 'sum',
              Cost: 'sum',
              Category: 'display_title',
            },
          },
        }}
      />
    </>
  );
};

export default Security;
